import React from 'react';
import certificationsData from '../data/certificationsData';

const Achievement = () => {
  return (
    <section className="Portfolio" id="achievement">
      <h2 className="heading">Certifications & <span>Professional Learning</span></h2>
      <div className="portfolio-container">
        {certificationsData.map((certificate) => (
          <div className="portfolio-box" key={certificate.title}>
            <img src={certificate.image} alt={certificate.alt} width="500" height="500" loading="lazy" decoding="async" />
            <div className="portfolio-layer">
              <h4>{certificate.title}</h4>
              <p>{certificate.description}</p>
              {certificate.link && (
                <a href={certificate.link} target="_blank" rel="noopener noreferrer">
                  <i className="fa-solid fa-up-right-from-square"></i>
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Achievement;
